import { alpha } from '@mui/material';
import { BRAND, brandAlpha } from '../theme/brandTokens';

export const CUSTOMER_COLORS = {
  primary: BRAND.accent,
  primaryDark: BRAND.accentDark,
  primaryMuted: BRAND.accentText,
  text: BRAND.text,
  error: '#ff4444',
};

export const customerPageTitleSx = {
  fontWeight: 700,
  color: CUSTOMER_COLORS.text,
  fontSize: { xs: '1.375rem', sm: '1.625rem' },
  lineHeight: 1.35,
};

export const customerPageSubtitleSx = {
  mt: 0.5,
};

export const customerSectionPaperSx = {
  elevation: 0,
  borderRadius: 2,
  border: `1px solid ${BRAND.line}`,
  bgcolor: 'background.paper',
};

export const customerEmptyStatePaperSx = {
  ...customerSectionPaperSx,
  bgcolor: brandAlpha('accent', 0.03),
};

export const customerCardPaperSx = {
  elevation: 0,
  borderRadius: 2,
  p: 2.5,
  border: `1px solid ${BRAND.line}`,
};

export const customerPrimaryButtonSx = {
  borderRadius: 2,
  fontWeight: 700,
  textTransform: 'none',
  fontSize: { xs: '1rem', sm: '1.05rem' },
  bgcolor: BRAND.accent,
  color: BRAND.onAccent,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: BRAND.accentDark,
    boxShadow: 'none',
  },
};

export const customerOutlinedPrimaryButtonSx = {
  borderColor: BRAND.accent,
  color: BRAND.accentText,
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    borderColor: BRAND.accent,
    bgcolor: brandAlpha('accent', 0.1),
  },
};

export const customerErrorButtonSx = {
  borderColor: CUSTOMER_COLORS.error,
  color: CUSTOMER_COLORS.error,
  textTransform: 'none',
  '&:hover': {
    borderColor: CUSTOMER_COLORS.error,
    bgcolor: alpha(CUSTOMER_COLORS.error, 0.1),
  },
};

export const customerLoadingSpinnerSx = {
  color: CUSTOMER_COLORS.primary,
};

export const customerAccentChipSx = {
  borderColor: brandAlpha('accent', 0.45),
  color: BRAND.accentText,
};

export const customerServiceItemSx = {
  p: 1.25,
  borderRadius: 1.5,
  bgcolor: brandAlpha('accent', 0.05),
  border: `1px solid ${brandAlpha('accent', 0.18)}`,
};
